export const profileActionsMenuStyles = {
	trigger: {
		whiteSpace: 'nowrap',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	},

	menuItem: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1
	}
};
